import React, { useEffect, useState } from "react";
import axios from "axios";
import "../styles/BlogPage.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import HomeFooter from "../components/Home/HomeFooter";
import MainHeader from "../components/Main/MainHeader";

const BlogPage = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    axios
      .get("https://anyworq.com/api/blogs")
      .then((res) => setBlogs(res.data))
      .catch((err) => console.error(err));
  }, []);

  const pageTitle = "Latest Blogs | Anyworq – A to Z Services in Bangalore";
  const pageDescription =
    "Read the latest blogs from Anyworq about services, tips, and updates. Trusted A to Z service platform in Bangalore.";
  const canonicalUrl = "https://www.anyworq.com/blogs";

  return (
    <>
      {/* SEO Meta */}
      <MainHeader />
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta
          name="keywords"
          content="Anyworq blogs, service tips, A to Z services Bangalore, blog updates"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={canonicalUrl} />

        {/* Open Graph */}
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:image" content="https://www.anyworq.com/Favicon.png" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content="https://www.anyworq.com/Favicon.png" />

        {/* Structured Data (JSON-LD Schema) */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Blog",
            "name": "Anyworq Blog",
            "url": "${canonicalUrl}",
            "description": "${pageDescription}",
            "publisher": {
              "@type": "Organization",
              "name": "Anyworq",
              "logo": {
                "@type": "ImageObject",
                "url": "https://www.anyworq.com/Favicon.png"
              }
            },
            "blogPost": ${JSON.stringify(
              blogs.map((blog) => ({
                "@type": "BlogPosting",
                "headline": blog.title,
                "image": blog.image || "https://www.anyworq.com/Favicon.png",
                "author": {
                  "@type": "Person",
                  "name": blog.author
                },
                "datePublished": blog.createdAt,
                "url": `https://www.anyworq.com/blogs/${blog._id}`,
                "description": blog.content.substring(0, 150) + "..."
              }))
            )}
          }
          `}
        </script>
      </Helmet>

      <div className="blog-page">
        <h2 className="blog-title">✨ Latest Blog Posts</h2>
        <div className="blog-grid">
          {blogs.length > 0 ? (
            blogs.map((blog) => (
              <div key={blog._id} className="blog-card">
                <Link
                  to={`/blogs/${blog._id}`}
                  className="blog-link"
                >
                  {blog.image && <img src={blog.image} alt={blog.title} />}
                  <div className="blog-content">
                    <h3>{blog.title}</h3>
                    <p>{blog.content.substring(0, 150)}...</p>
                    <p className="blog-meta">
                      <strong>By:</strong> {blog.author} |{" "}
                      {new Date(blog.createdAt).toLocaleDateString()}
                    </p>
                  </div>
                </Link>
              </div>
            ))
          ) : (
            <p className="no-blogs">
              No blogs available yet. Add one from Post Blog.
            </p>
          )}
        </div>
      </div>
      <HomeFooter />
    </>
  );
};

export default BlogPage;
